var _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCopyBlueIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.75 12C4.2 12 4.5 11.7 4.5 11.25C4.5 10.8 4.2 10.5 3.75 10.5H3C2.55 10.5 2.25 10.2 2.25 9.75V3C2.25 2.55 2.55 2.25 3 2.25H9.75C10.2 2.25 10.5 2.55 10.5 3V3.75C10.5 4.2 10.8 4.5 11.25 4.5C11.7 4.5 12 4.2 12 3.75V3C12 1.725 11.025 0.75 9.75 0.75H3C1.725 0.75 0.75 1.725 0.75 3V9.75C0.75 11.025 1.725 12 3 12H3.75ZM15 6H8.25C6.975 6 6 6.975 6 8.25V15C6 16.275 6.975 17.25 8.25 17.25H15C16.275 17.25 17.25 16.275 17.25 15V8.25C17.25 6.975 16.275 6 15 6ZM15.75 15C15.75 15.45 15.45 15.75 15 15.75H8.25C7.8 15.75 7.5 15.45 7.5 15V8.25C7.5 7.8 7.8 7.5 8.25 7.5H15C15.45 7.5 15.75 7.8 15.75 8.25V15Z",
    fill: "#212529"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_10091_11945",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.75 12C4.2 12 4.5 11.7 4.5 11.25C4.5 10.8 4.2 10.5 3.75 10.5H3C2.55 10.5 2.25 10.2 2.25 9.75V3C2.25 2.55 2.55 2.25 3 2.25H9.75C10.2 2.25 10.5 2.55 10.5 3V3.75C10.5 4.2 10.8 4.5 11.25 4.5C11.7 4.5 12 4.2 12 3.75V3C12 1.725 11.025 0.75 9.75 0.75H3C1.725 0.75 0.75 1.725 0.75 3V9.75C0.75 11.025 1.725 12 3 12H3.75ZM15 6H8.25C6.975 6 6 6.975 6 8.25V15C6 16.275 6.975 17.25 8.25 17.25H15C16.275 17.25 17.25 16.275 17.25 15V8.25C17.25 6.975 16.275 6 15 6ZM15.75 15C15.75 15.45 15.45 15.75 15 15.75H8.25C7.8 15.75 7.5 15.45 7.5 15V8.25C7.5 7.8 7.8 7.5 8.25 7.5H15C15.45 7.5 15.75 7.8 15.75 8.25V15Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_10091_11945)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H18V18H0V0Z",
    fill: "#3876BB"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyBlueIcon);
export default __webpack_public_path__ + "static/media/CopyBlueIcon.56d2de9625631c77cd59e7fde087349e.svg";
export { ForwardRef as ReactComponent };